import { Skeleton, TableCell, TableRow } from "@mui/material";

export function LoadingSectionRow({ colSpan }: { colSpan: number }) {
  return (
    <TableRow className="structural-row">
      <TableCell colSpan={colSpan} sx={{ padding: "0.25rem 0" }}>
        <Skeleton
          data-testid="incident-list-skeleton"
          sx={{
            padding: 0,
            width: "100%",
            minHeight: "3rem",
            transform: "unset",
          }}
        />
      </TableCell>
    </TableRow>
  );
}
